
import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import AppIcon from 'shared-components/AppIcon';
import { FlexContainer } from 'base-components';
import { Row, Column, ExcessTotal, Number, Text, Icon } from '../../common';

const _renderCell = (item, dataIndex) => (get(item, dataIndex, '-'));

const ClickableLink = styled.a`
    color: black;
`;

export const substituteColumns = [
    {
        title: 'Producto',
        dataIndex: 'name',
        key: 'product',
        index: 1,
        columnStyle: { textAlign: 'left' },
        render: (item, dataIndex, { onRowClick, parent }) => (
            <div>
                <p className='truncate' style={{ width: 150 }}>{get(item, dataIndex, dataIndex)}</p>
                <FlexContainer mY={5} align='center'>
                    <Icon name='barcode' color='#666666' size={15} right={5} />
                    <Text text={get(item, 'ean', 'No Disponible')} color='#666666' size={11} lineHeight={1} />
                </FlexContainer>
            </div>
        )
    },
    {
        title: 'Marca',
        dataIndex: 'brandName',
        key: 'brandName',
        index: 2,
        columnStyle: { textAlign: 'left' },
        render: (item, dataIndex, { onRowClick, parent }) => (
            <div>
                {/* <p className='truncate' style={{ width: 210 }}>{get(item, dataIndex, dataIndex)}</p> */}
                <p>{get(item, dataIndex, dataIndex)}</p>
            </div>
        )
    },
    {
        title: '',
        dataIndex: 'pickingQuantity',
        key: 'picked',
        index: 3,
        columnStyle: { textAlign: 'left' },
        render: (item, dataIndex) => {
            const measureUnit = (get(item, 'unit', 'un')).toLowerCase();
            const value = get(item, dataIndex);
            const valueToShow = measureUnit === 'kg' ? parseFloat(value).toFixed(3) : value;
            return `${(String(valueToShow).replace('.', ','))} ${measureUnit}`;
        }
    },
    {
        title: '',
        dataIndex: 'arrow',
        key: 'arrow',
        index: 4,
        render: () => (
            <FlexContainer justify='center'>
                <Row>
                    <Column>{null}</Column>
                    <Column flex={2} align='flex-start'>
                        <AppIcon name='ic-replace' size='22' />
                    </Column>
                    <Column>{null}</Column>
                </Row>
            </FlexContainer>
        )
    },
    {
        title: 'Precio unitario',
        dataIndex: 'sellingPrice',
        key: 'list_price',
        index: 5,
        columnStyle: { textAlign: 'right' },
        render: (item, dataIndex) => {
            const value = _renderCell(item, dataIndex);
            return (
                <div>
                    <span>
                        <Number value={value} />
                    </span>
                </div>
            );
        }
    },
    {
        title: 'Total solicitado',
        dataIndex: 'sellingPrice',
        key: 'sale_price',
        index: 6,
        render: () => <Text text='-' />
    },
    {
        title: 'Total pickeado',
        dataIndex: 'sellingPrice',
        key: 'final_price',
        index: 7,
        columnStyle: { textAlign: 'right' },
        render: (item, dataIndex) => {
            const value = parseInt(get(item, dataIndex)) * parseFloat(get(item, 'pickingQuantity'));
            return <Text text={value > 0 ? <Number value={value} /> : '-'} strong size={11} />;
        }
    },
    {
        title: '',
        key: 'dash',
        index: 8,
        render: () => <Text text='-' />
    }
];

export const excessColumns = [
    { title: 'excess',
        index: 1,
        dataIndex: 'picking.excess',
        render: (item, dataIndex) => (
            get(item, dataIndex) && <ExcessTotal item={get(item, dataIndex)} />
        )
    }
];
